module.exports = __webpack_public_path__ + "img/Category.462026a2.svg";